import FaqGeneral from './GeneralFaqContent';
import FaqGeneralSF from './GeneralFaqContentSF';
import FaqEv from './NewEvFaqContent';
import FaqEvSF from './NewEVFaqContentSF';
import FaqEvOTT from './NewEVFaqContentOTT';
import FaqEligibility from './EligibilityFaqContent';
import FaqEligibilitySF from './EligibilityFaqContentSF';
import FaqEligibilityOTT from './EligibilityFaqContentOTT';
import FaqSignup from './SignupFaqContent';
import FaqSignupSF from './SignupFaqContentSF';
import FaqSignupOTT from './SignupFaqContentOTT';
import FaqReferral from './ReferralFaqContent';
import FaqContact from './ContactFaqContent';
import FaqSafety from './SafetyFaqContent';
import FaqSafetySF from './SafetyFaqContentSF';

const faqCategories = city => {
  if (city.includes('tor')) {
    return [
      { type: 'General', content: FaqGeneral },
      { type: 'Autzu EV', content: FaqEv },
      { type: 'Eligibility', content: FaqEligibility },
      { type: 'Signing up', content: FaqSignup },
      { type: 'Referrals & Rewards', content: FaqReferral },
      { type: 'Safety & Support', content: FaqSafety },
      { type: 'Contact Us', content: FaqContact }
    ];
  } else if (city.includes('ott')) {
    return [
      { type: 'General', content: FaqGeneral },
      { type: 'Autzu EV', content: FaqEvOTT },
      { type: 'Eligibility', content: FaqEligibilityOTT },
      { type: 'Signing up', content: FaqSignupOTT },
      { type: 'Referrals & Rewards', content: FaqReferral },
      { type: 'Safety & Support', content: FaqSafety },
      { type: 'Contact Us', content: FaqContact }
    ];
  } else {
    return [
      { type: 'General', content: FaqGeneralSF },
      { type: 'Autzu EV', content: FaqEvSF },
      { type: 'Eligibility', content: FaqEligibilitySF },
      { type: 'Signing up', content: FaqSignupSF },
      { type: 'Referrals & Rewards', content: FaqReferral },
      { type: 'Safety & Support', content: FaqSafetySF },
      { type: 'Contact Us', content: FaqContact }
    ];
  }
};

const faqGeneralContent = city => {
  if (city.includes('tor')) {
    return FaqGeneral;
  } else if (city.includes('ott')) {
    return FaqGeneral;
  } else {
    return FaqGeneralSF;
  }
};

const faqEligibilityContent = city => {
  if (city.includes('tor')) {
    return FaqEligibility;
  } else if (city.includes('ott')) {
    return FaqEligibilityOTT;
  } else {
    return FaqEligibilitySF;
  }
};

const FaqSignupContent = city => {
  if (city.includes('tor')) {
    return FaqSignup;
  } else if (city.includes('ott')) {
    return FaqSignupOTT;
  } else {
    return FaqSignupSF;
  }
};

const faqEVContent = city => {
  if (city.includes('tor')) {
    return FaqEv;
  } else if (city.includes('ott')) {
    return FaqEvOTT;
  } else {
    return FaqEvSF;
  }
};

export {
  faqCategories,
  faqGeneralContent,
  faqEligibilityContent,
  FaqSignupContent,
  faqEVContent
};



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/helperFunctions.js